/**
 * Golf Gloves Find Your Fit — premium visual wizard.
 * Uses GgFittingEngine (client MOI continuum + KBS shaft chart + grip).
 */
(function () {
  function findProduct(catalog, handle) {
    if (!catalog || !catalog.length) {
      return { handle: handle, title: handle, url: '/products/' + handle, available: true };
    }
    for (var i = 0; i < catalog.length; i++) {
      if (catalog[i].handle === handle) return catalog[i];
    }
    return { handle: handle, title: handle, url: '/products/' + handle, available: true };
  }

  function recommend(input, catalog) {
    var engine = window.GgFittingEngine;
    if (!engine) {
      console.error('GgFittingEngine missing');
      return null;
    }
    var result = engine.recommend({
      height: input.height,
      wtf: input.wtf,
      weight: input.weight,
      age: input.age,
      ironSpeed: input.ironSpeed,
      ironDist: input.ironDist,
      driverSpeed: input.driverSpeed,
      driverDist: input.driverDist,
      tempo: input.tempo,
      transition: input.transition,
      skill: input.skill,
      handMeasure: input.handMeasure,
      ballFlight: input.ballFlight,
      ironLength: input.ironLength,
      driverBallSpeed: input.driverBallSpeed,
      ironBallSpeed: input.ironBallSpeed,
      ironSpin: input.ironSpin,
      playerFeedback: input.playerFeedback,
      swingVideoName: input.swingVideoName,
      heightUnknown: input.heightUnknown,
      ageUnknown: input.ageUnknown,
      weightUnknown: input.weightUnknown,
      wtfUnknown: input.wtfUnknown,
      handUnknown: input.handUnknown,
      ironLengthUnknown: input.ironLengthUnknown,
      driverSpeedUnknown: input.driverSpeedUnknown,
      driverDistUnknown: input.driverDistUnknown,
      driverBallSpeedUnknown: input.driverBallSpeedUnknown,
      ironSpeedUnknown: input.ironSpeedUnknown,
      ironBallSpeedUnknown: input.ironBallSpeedUnknown,
      ironDistUnknown: input.ironDistUnknown,
      ironSpinUnknown: input.ironSpinUnknown
    });
    var series = result.series;
    result.products = [
      Object.assign({ role: 'Irons' }, findProduct(catalog, series.ironHandle)),
      Object.assign({ role: 'Wedges' }, findProduct(catalog, series.wedgeHandle)),
      Object.assign({ role: 'Putter' }, findProduct(catalog, series.putterHandle))
    ];
    return result;
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || '${{amount}}');
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function fitProperties(result) {
    if (window.GgFittingEngine && window.GgFittingEngine.fitProperties) {
      return window.GgFittingEngine.fitProperties(result);
    }
    return {
      Series: result.series.label,
      Length: result.length,
      Lie: result.lie,
      Flex: result.flex,
      Shaft: result.shaftModel || result.shaft,
      'Fit MOI': String(result.moi)
    };
  }

  function addItemsToCart(items, btn) {
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (btn) btn.disabled = true;
    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart error');
        window.location.href = rootUrl + 'cart';
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        alert('Could not add to cart. Open a product page to continue.');
      });
  }

  function dotsHtml(score) {
    var html = '<span class="gg-fyf__dots">';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="gg-fyf__dot' + (i <= score ? ' is-on' : '') + '"></span>';
    }
    return html + '</span>';
  }

  function formatHeight(inches) {
    var n = Number(inches);
    var ft = Math.floor(n / 12);
    var inch = Math.round(n % 12);
    if (inch === 12) {
      ft += 1;
      inch = 0;
    }
    return ft + "'" + inch + '"';
  }

  function formatLive(format, value, unitMode) {
    var n = Number(value);
    if (format === 'height') return formatHeight(n);
    if (format === 'inch') return n.toFixed(n % 1 ? 1 : 0) + '"';
    if (format === 'lbs') return String(Math.round(n));
    if (format === 'age') return String(Math.round(n));
    if (unitMode === 'kmh') return Math.round(n * 1.60934) + ' km/h';
    return Math.round(n) + ' mph';
  }

  function updateSwingArt(root, name, index) {
    if (name === 'iron_speed') {
      var arcs = root.querySelectorAll('.gg-fyf__arc');
      arcs.forEach(function (arc, i) {
        arc.style.opacity = i <= Math.min(index, arcs.length - 1) ? '1' : '0.25';
        if (i === Math.min(index, arcs.length - 1)) arc.style.stroke = '#c8a45d';
        else if (i < index) arc.style.stroke = '#bdbdbd';
        else arc.style.stroke = '#cfcfcf';
      });
      var club = root.querySelector('.gg-fyf__club');
      if (club) {
        var rot = (index / Math.max(1, 6)) * 28 - 8;
        club.style.transformOrigin = '248px 95px';
        club.style.transform = 'rotate(' + rot.toFixed(1) + 'deg)';
      }
    }
    if (name === 'driver_speed') {
      var flight = root.querySelector('.gg-fyf__flight');
      var ball = root.querySelector('.gg-fyf__ball');
      var paths = [
        'M48 170c60-20 110-90 160-110 50-20 90-10 130 30',
        'M48 175c55-10 105-70 155-95 55-28 100-8 140 38',
        'M48 168c50-30 100-105 155-120 60-16 105 5 145 50',
        'M48 165c45-40 95-120 150-130 70-12 115 18 155 62',
        'M48 160c40-50 90-135 145-140 80-8 125 30 165 75'
      ];
      var pathIndex = Math.min(index, paths.length - 1);
      if (flight) {
        flight.style.strokeDashoffset = String(24 - pathIndex * 4);
        flight.setAttribute('d', paths[pathIndex]);
      }
      if (ball) {
        var positions = [
          [300, 120],
          [318, 105],
          [338, 90],
          [352, 78],
          [365, 68]
        ];
        var pos = positions[Math.min(pathIndex, positions.length - 1)];
        ball.setAttribute('cx', pos[0]);
        ball.setAttribute('cy', pos[1]);
      }
    }
  }

  function initRangeSliders(root, getUnitMode) {
    root.querySelectorAll('[data-gg-fyf-slider]:not([data-gg-fyf-discrete])').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="range"]');
      var ticks = wrap.querySelector('[data-gg-fyf-ticks]');
      var format = wrap.getAttribute('data-format');
      var name = wrap.getAttribute('data-name');
      var live = root.querySelector('[data-gg-fyf-live="' + name + '"]');
      var hint =
        root.querySelector('[data-gg-fyf-control-group="' + name + '"] [data-gg-fyf-unit-hint]') ||
        wrap.querySelector('[data-gg-fyf-unit-hint]');
      if (!input) return;

      if (ticks && !ticks.children.length) {
        var minTick = Number(input.min);
        var maxTick = Number(input.max);
        var midTick = (minTick + maxTick) / 2;
        [minTick, midTick, maxTick].forEach(function (v, i) {
          var span = document.createElement('span');
          if (format === 'height') span.textContent = formatHeight(Math.round(v));
          else if (format === 'inch') span.textContent = Number(v).toFixed(v % 1 ? 1 : 0) + '"';
          else if (format === 'mph') span.textContent = String(Math.round(v));
          else span.textContent = String(Math.round(v));
          if (i === 1) span.style.opacity = '0.55';
          ticks.appendChild(span);
        });
      }

      function sync() {
        var val = Number(input.value);
        var min = Number(input.min);
        var max = Number(input.max);
        var t = max === min ? 0 : (val - min) / (max - min);
        input.style.setProperty('--gg-fyf-pct', t * 100 + '%');
        var mode = getUnitMode ? getUnitMode() : 'mph';

        if (live) {
          if (format === 'height') live.textContent = formatLive('height', val);
          else if (format === 'inch') live.textContent = Number(val).toFixed(val % 1 ? 1 : 0);
          else if (format === 'lbs') live.textContent = formatLive('lbs', val);
          else if (format === 'age') live.textContent = formatLive('age', val);
          else if (format === 'mph') {
            live.textContent = mode === 'kmh' ? String(Math.round(val * 1.60934)) : String(Math.round(val));
          } else live.textContent = String(val);
        }

        if (format === 'mph' && hint) {
          hint.textContent = mode === 'kmh' ? 'km/h' : 'mph';
        }

        if (name === 'driver_speed') {
          var artIndex = Math.min(4, Math.max(0, Math.round(((val - min) / Math.max(1, max - min)) * 4)));
          updateSwingArt(root, 'driver_speed', artIndex);
        }

        if (name === 'height') {
          var golfer = root.querySelector('.gg-fyf__golfer');
          if (golfer) {
            var scale = 0.78 + ((val - 48) / 30) * 0.34;
            golfer.style.transform = 'scaleY(' + scale.toFixed(3) + ')';
            golfer.style.transformOrigin = '210px 190px';
          }
        }

        if (name === 'wtf') {
          var topY = 178 - (48 + t * 95);
          var line = root.querySelector('.gg-fyf__wtf-line');
          var top = root.querySelector('.gg-fyf__wtf-top');
          var ball = root.querySelector('.gg-fyf__wtf-ball');
          var curve = root.querySelector('.gg-fyf__wtf-curve');
          if (line) {
            line.setAttribute('y1', String(topY));
            line.setAttribute('y2', '178');
          }
          if (top) top.setAttribute('cy', String(topY));
          if (ball) {
            ball.style.transform = 'scale(' + (0.92 + t * 0.2).toFixed(3) + ')';
          }
          if (curve) {
            var bend = 70 + t * 28;
            curve.setAttribute(
              'd',
              'M186 108c' + (36 + t * 14) + ' 8 ' + (70 + t * 20) + ' ' + (30 + t * 12) + ' 92 ' + bend
            );
          }
        }

        if (name === 'weight') {
          var needle = root.querySelector('.gg-fyf__weight-needle');
          var fill = root.querySelector('.gg-fyf__weight-fill');
          var x = 58 + t * 64;
          if (needle) needle.setAttribute('transform', 'translate(' + x.toFixed(1) + ' 52)');
          if (fill) fill.setAttribute('width', String(Math.max(12, 8 + t * 88)));
        }

        if (name === 'age') {
          var hour = root.querySelector('.gg-fyf__age-hour');
          var minute = root.querySelector('.gg-fyf__age-minute');
          var hourDeg = t * 300 - 20;
          var minDeg = t * 360;
          if (hour) hour.setAttribute('transform', 'translate(90 50) rotate(' + hourDeg.toFixed(1) + ')');
          if (minute) {
            minute.style.setProperty('--fyf-age-min', minDeg.toFixed(1) + 'deg');
            minute.setAttribute('transform', 'translate(90 50) rotate(' + minDeg.toFixed(1) + ')');
          }
        }

        if (name === 'hand_measure') {
          var handArt = root.querySelector('[data-gg-fyf-visual="grip"] .gg-fyf__live');
          if (handArt) handArt.style.transform = 'scale(' + (0.92 + t * 0.2).toFixed(3) + ')';
        }
      }

      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      wrap._ggFyfSync = sync;
      sync();
    });
  }

  function initDiscreteSliders(root, getUnitMode) {
    root.querySelectorAll('[data-gg-fyf-discrete]').forEach(function (wrap) {
      var labels = (wrap.getAttribute('data-labels') || '').split('|');
      var values = (wrap.getAttribute('data-values') || '').split('|').map(Number);
      var index = Number(wrap.getAttribute('data-index') || 0);
      var ticks = wrap.querySelector('[data-gg-fyf-ticks]');
      var thumb = wrap.querySelector('[data-gg-fyf-thumb]');
      var hidden = wrap.querySelector('input[type="hidden"]');
      var hint = wrap.querySelector('[data-gg-fyf-unit-hint]');
      var track = wrap.querySelector('.gg-fyf__track');

      function setIndex(i) {
        index = Math.max(0, Math.min(values.length - 1, i));
        wrap.setAttribute('data-index', String(index));
        if (hidden) hidden.value = String(values[index]);
        if (ticks) {
          Array.prototype.forEach.call(ticks.children, function (el, idx) {
            el.classList.toggle('is-active', idx === index);
          });
        }
        if (thumb && values.length > 1) {
          var pct = (index / (values.length - 1)) * 100;
          thumb.style.left = pct + '%';
        }
        var name = wrap.getAttribute('data-name');
        if (hint && (name === 'driver_speed' || name === 'iron_speed')) {
          var mode = getUnitMode ? getUnitMode() : 'mph';
          hint.textContent = formatLive('mph', values[index], mode);
        }
        if (name === 'hand_measure') {
          var live = root.querySelector('[data-gg-fyf-live="hand_measure"]');
          if (live) live.textContent = String(values[index]);
        }
        updateSwingArt(root, name, index);
      }

      function pointerToIndex(clientX) {
        if (!track) return index;
        var rect = track.getBoundingClientRect();
        var ratio = (clientX - rect.left) / Math.max(1, rect.width);
        return Math.round(Math.max(0, Math.min(1, ratio)) * (values.length - 1));
      }

      if (ticks) {
        ticks.innerHTML = '';
        labels.forEach(function (label, i) {
          var span = document.createElement('span');
          span.textContent = label;
          span.addEventListener('click', function () {
            setIndex(i);
          });
          ticks.appendChild(span);
        });
      }

      if (track) {
        track.addEventListener('click', function (e) {
          setIndex(pointerToIndex(e.clientX));
        });
      }

      if (thumb) {
        var dragging = false;
        thumb.addEventListener('pointerdown', function (e) {
          dragging = true;
          thumb.setPointerCapture(e.pointerId);
          e.preventDefault();
        });
        thumb.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          setIndex(pointerToIndex(e.clientX));
        });
        thumb.addEventListener('pointerup', function () {
          dragging = false;
        });
        thumb.addEventListener('pointercancel', function () {
          dragging = false;
        });
        thumb.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
            e.preventDefault();
            setIndex(index + 1);
          }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
            e.preventDefault();
            setIndex(index - 1);
          }
        });
      }

      setIndex(index);
    });
  }

  function initUnitToggle(root) {
    var mode = 'mph';
    root.querySelectorAll('[data-gg-fyf-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = btn.getAttribute('data-gg-fyf-unit') || 'mph';
        root.querySelectorAll('[data-gg-fyf-unit]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        root.querySelectorAll('[data-gg-fyf-discrete]').forEach(function (wrap) {
          var name = wrap.getAttribute('data-name');
          if (name !== 'driver_speed' && name !== 'iron_speed') return;
          var values = (wrap.getAttribute('data-values') || '').split('|').map(Number);
          var index = Number(wrap.getAttribute('data-index') || 0);
          var hint = wrap.querySelector('[data-gg-fyf-unit-hint]');
          if (hint) hint.textContent = formatLive('mph', values[index], mode);
        });
        root.querySelectorAll('[data-gg-fyf-slider][data-format="mph"]').forEach(function (wrap) {
          if (typeof wrap._ggFyfSync === 'function') wrap._ggFyfSync();
        });
      });
    });
    return function () {
      return mode;
    };
  }

  function isIdk(root, name) {
    var cb = root.querySelector('[data-gg-fyf-idk="' + name + '"]');
    return !!(cb && cb.checked);
  }

  function fieldValue(root, name) {
    if (isIdk(root, name)) return '';
    var el = root.querySelector('[name="' + name + '"]');
    if (!el) return '';
    if (el.type === 'radio') {
      var checked = root.querySelector('[name="' + name + '"]:checked');
      return checked ? checked.value : '';
    }
    if (el.type === 'file') {
      return el.files && el.files[0] ? el.files[0].name : '';
    }
    return el.value;
  }

  function setGroupDisabled(root, name, disabled) {
    root.querySelectorAll('[data-gg-fyf-control-group="' + name + '"]').forEach(function (group) {
      group.classList.toggle('is-idk', disabled);
      group.querySelectorAll('input, button, textarea, select').forEach(function (el) {
        if (el.hasAttribute('data-gg-fyf-idk')) return;
        if (el.type === 'checkbox' || el.type === 'radio') {
          el.disabled = disabled;
          return;
        }
        el.disabled = disabled;
      });
    });

    // Discrete / range wrappers tied by data-name
    root.querySelectorAll('[data-name="' + name + '"]').forEach(function (wrap) {
      wrap.classList.toggle('is-idk', disabled);
      wrap.querySelectorAll('input, button').forEach(function (el) {
        el.disabled = disabled;
      });
    });

    // Choice grids for radio groups
    if (name === 'ball_flight' || name === 'tempo' || name === 'transition') {
      root.querySelectorAll('[name="' + name + '"]').forEach(function (el) {
        el.disabled = disabled;
        var card = el.closest('.gg-fyf__card');
        if (card) card.classList.toggle('is-idk', disabled);
      });
    }
  }

  function initIdk(root) {
    root.querySelectorAll('[data-gg-fyf-idk]').forEach(function (cb) {
      var name = cb.getAttribute('data-gg-fyf-idk');
      function sync() {
        setGroupDisabled(root, name, cb.checked);
      }
      cb.addEventListener('change', sync);
      sync();
    });
  }

  function initUpload(root) {
    var input = root.querySelector('[name="swing_video"]');
    var label = root.querySelector('[data-gg-fyf-upload-label]');
    if (!input || !label) return;
    input.addEventListener('change', function () {
      if (input.files && input.files[0]) {
        label.textContent = input.files[0].name;
      } else {
        label.textContent = 'Choose video';
      }
    });
  }

  function init(root) {
    if (root.__ggFyfBound) return;
    root.__ggFyfBound = true;

    var form = root.querySelector('form.gg-fyf__form') || root.querySelector('[data-gg-fyf-form]');
    var results = root.querySelector('[data-gg-fyf-results]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-gg-fyf-step]'));
    var stepLabel = root.querySelector('[data-gg-fyf-step-label]');
    var progressBar = root.querySelector('[data-gg-fyf-progress]');
    var progressCheck = root.querySelector('[data-gg-fyf-check]');
    var resetIcons = root.querySelectorAll('[data-gg-fyf-recalc]');
    var catalogEl = root.querySelector('[data-gg-fyf-catalog]');
    var catalog = [];
    var isIntake = root.getAttribute('data-gg-fyf-intake') === 'true';
    try {
      catalog = catalogEl ? JSON.parse(catalogEl.textContent) : [];
    } catch (_) {}

    var stepIndex = 0;
    var lastResult = null;
    var totalSteps = steps.length;
    var getUnitMode = initUnitToggle(root);

    initRangeSliders(root, getUnitMode);
    initDiscreteSliders(root, getUnitMode);
    initIdk(root);
    initUpload(root);

    function compileIntakeBody() {
      var lines = [
        'JUNIOR FORGED — PLAYER FIT INTAKE',
        'Route to: jesse@juniorforged.com',
        'Submitted from: ' + window.location.href,
        ''
      ];
      if (!form) return lines.join('\n');
      var fd = new FormData(form);
      fd.forEach(function (value, key) {
        if (!key || key === 'form_type' || key === 'utf8') return;
        if (key === 'contact[body]' || key === 'contact[Improve]') return;
        var label = key.replace(/^contact\[/, '').replace(/\]$/, '');
        var v = String(value || '').trim();
        if (!v) return;
        lines.push(label + ': ' + v);
      });
      var improve = [];
      root.querySelectorAll('[data-gg-fyf-improve-opt]:checked').forEach(function (el) {
        improve.push(el.value);
      });
      if (improve.length) lines.push('Improve: ' + improve.join(', '));
      root.querySelectorAll('[data-gg-fyf-idk]:checked').forEach(function (el) {
        lines.push('Unknown: ' + el.getAttribute('data-gg-fyf-idk'));
      });
      return lines.join('\n');
    }

    function prepareIntakePayload() {
      var improveField = form.querySelector('[data-gg-fyf-improve]');
      if (improveField) {
        var improve = [];
        root.querySelectorAll('[data-gg-fyf-improve-opt]:checked').forEach(function (el) {
          improve.push(el.value);
        });
        improveField.value = improve.join(', ');
      }
      var body = form.querySelector('[data-gg-fyf-body]');
      if (body) body.value = compileIntakeBody();
    }

    function firstInvalidField() {
      if (!form) return null;
      return Array.prototype.find.call(form.querySelectorAll('input, select, textarea'), function (el) {
        return el.willValidate && !el.disabled && !el.checkValidity();
      });
    }

    function revealInvalidField(el) {
      if (!el) return;
      var panel = el.closest('[data-gg-fyf-step]');
      if (panel) {
        var idx = Array.prototype.indexOf.call(steps, panel);
        if (idx >= 0) showStep(idx);
      }
      setTimeout(function () {
        try {
          el.focus({ preventScroll: false });
        } catch (_) {
          try {
            el.focus();
          } catch (__) {}
        }
        if (typeof el.reportValidity === 'function') el.reportValidity();
      }, 40);
    }

    function submitIntake() {
      if (!form) return;
      var email = form.querySelector('[name="contact[email]"]');
      if (email && !String(email.value || '').trim()) {
        alert('Please enter an email so Junior Forged can send your fitting report.');
        showStep(steps.length - 2);
        email.focus();
        return;
      }
      prepareIntakePayload();
      var invalid = firstInvalidField();
      if (invalid) {
        revealInvalidField(invalid);
        return;
      }
      // Prefer the native submit button so Shopify CAPTCHA can attach tokens.
      var submitBtn = form.querySelector('[data-gg-fyf-submit]');
      if (submitBtn && typeof form.requestSubmit === 'function') form.requestSubmit(submitBtn);
      else if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }

    function showStep(i) {
      stepIndex = i;
      steps.forEach(function (el, idx) {
        el.hidden = idx !== i;
      });
      var title = steps[i].getAttribute('data-step-title') || 'STEP 0' + (i + 1);
      if (stepLabel) stepLabel.textContent = '/ ' + title;
      if (progressBar) {
        progressBar.style.width = ((i + 1) / totalSteps) * 100 + '%';
      }
      var completed = i === totalSteps - 1;
      if (progressCheck) progressCheck.hidden = !completed;
      resetIcons.forEach(function (el) {
        if (el.classList.contains('gg-fyf__close')) el.hidden = !completed;
      });
      root.setAttribute('data-step', String(i + 1));
    }

    function readInput() {
      var tempo = fieldValue(root, 'tempo') || 'normal';
      if (isIdk(root, 'tempo')) tempo = 'normal';
      var transition = fieldValue(root, 'transition') || 'normal';
      if (isIdk(root, 'transition')) transition = '';
      var ballFlight = fieldValue(root, 'ball_flight') || 'medium';
      if (isIdk(root, 'ball_flight')) ballFlight = '';

      return {
        height: fieldValue(root, 'height'),
        wtf: fieldValue(root, 'wtf'),
        weight: fieldValue(root, 'weight'),
        age: fieldValue(root, 'age'),
        ironSpeed: fieldValue(root, 'iron_speed'),
        ironDist: fieldValue(root, 'iron_dist'),
        driverSpeed: fieldValue(root, 'driver_speed'),
        driverDist: fieldValue(root, 'driver_dist'),
        tempo: tempo,
        transition: transition,
        skill: fieldValue(root, 'skill') || 'advanced',
        handMeasure: fieldValue(root, 'hand_measure'),
        ballFlight: ballFlight,
        ironLength: fieldValue(root, 'iron_length'),
        driverBallSpeed: fieldValue(root, 'driver_ball_speed'),
        ironBallSpeed: fieldValue(root, 'iron_ball_speed'),
        ironSpin: fieldValue(root, 'iron_spin'),
        playerFeedback: fieldValue(root, 'player_feedback'),
        swingVideoName: fieldValue(root, 'swing_video'),
        heightUnknown: isIdk(root, 'height'),
        ageUnknown: isIdk(root, 'age'),
        weightUnknown: isIdk(root, 'weight'),
        wtfUnknown: isIdk(root, 'wtf'),
        handUnknown: isIdk(root, 'hand_measure'),
        ironLengthUnknown: isIdk(root, 'iron_length'),
        driverSpeedUnknown: isIdk(root, 'driver_speed'),
        driverDistUnknown: isIdk(root, 'driver_dist'),
        driverBallSpeedUnknown: isIdk(root, 'driver_ball_speed'),
        ironSpeedUnknown: isIdk(root, 'iron_speed'),
        ironBallSpeedUnknown: isIdk(root, 'iron_ball_speed'),
        ironDistUnknown: isIdk(root, 'iron_dist'),
        ironSpinUnknown: isIdk(root, 'iron_spin')
      };
    }

    function renderIntake(result) {
      var el = results.querySelector('[data-gg-fyf-intake]');
      if (!el) return;
      var a = result.answers || {};
      var rows = [
        ['Experience', result.skillLabel],
        ['Tempo', result.tempoLabel],
        ['Transition', result.transitionLabel],
        ['Ball flight', result.ballFlightLabel],
        ['Height', a.height],
        ['Age', a.age],
        ['Weight', a.weight],
        ['Wrist-to-floor', a.wtf],
        ['Hand length', a.handMeasure],
        ['Current 6i length', a.ironLength],
        ['Driver swing speed', a.driverSpeed],
        ['Driver total distance', a.driverDist],
        ['Driver ball speed', a.driverBallSpeed],
        ['6i swing speed', a.ironSpeed],
        ['6i ball speed', a.ironBallSpeed],
        ['6i carry', a.ironDist],
        ['6i spin', a.ironSpin]
      ];
      var html = '<h3 class="gg-fyf__intake-title">Your fitting intake</h3><ul class="gg-fyf__intake-list">';
      rows.forEach(function (row) {
        if (!row[1]) return;
        html +=
          '<li><span>' +
          row[0] +
          '</span><strong>' +
          row[1] +
          '</strong></li>';
      });
      if (a.playerFeedback) {
        html +=
          '<li class="gg-fyf__intake-note"><span>Player feedback</span><strong>' +
          a.playerFeedback.replace(/</g, '&lt;') +
          '</strong></li>';
      }
      if (a.swingVideo) {
        html +=
          '<li><span>Swing video</span><strong>' +
          a.swingVideo.replace(/</g, '&lt;') +
          '</strong></li>';
      }
      html += '</ul>';
      el.innerHTML = html;
    }

    function renderResults(result) {
      lastResult = result;
      var summary = results.querySelector('[data-gg-fyf-summary]');
      if (summary) summary.textContent = result.summary;
      results.querySelector('[data-gg-fyf-series]').textContent = result.series.label;
      var blurb = results.querySelector('[data-gg-fyf-blurb]');
      if (blurb) blurb.textContent = result.series.blurb || '';
      results.querySelector('[data-gg-fyf-length]').textContent = result.length;
      results.querySelector('[data-gg-fyf-lie]').textContent = result.lie;
      results.querySelector('[data-gg-fyf-flex]').textContent = result.flex;
      var shaftEl = results.querySelector('[data-gg-fyf-shaft]');
      if (shaftEl) shaftEl.textContent = result.shaftModel || result.shaft;
      var shaftCat = results.querySelector('[data-gg-fyf-shaft-cat]');
      if (shaftCat) shaftCat.textContent = result.shaftCategory || '';
      var gripEl = results.querySelector('[data-gg-fyf-grip]');
      if (gripEl) {
        gripEl.textContent =
          result.grip + (result.gloveSize ? ' (glove ' + result.gloveSize + ')' : '');
      }
      results.querySelector('[data-gg-fyf-moi]').textContent =
        result.moi.toLocaleString('en-US') + ' kg·cm²';
      var moiCat = results.querySelector('[data-gg-fyf-moi-cat]');
      if (moiCat) moiCat.textContent = result.moiCategory || '';

      renderIntake(result);

      var ratingsEl = results.querySelector('[data-gg-fyf-ratings]');
      if (ratingsEl) {
        var ratings = result.series.ratings || {};
        ratingsEl.innerHTML = Object.keys(ratings)
          .map(function (key) {
            return (
              '<li class="gg-fyf__rating"><span class="gg-fyf__rating-label">' +
              key +
              '</span>' +
              dotsHtml(ratings[key]) +
              '</li>'
            );
          })
          .join('');
      }

      var media = results.querySelector('[data-gg-fyf-best-media]');
      if (media) {
        var iron = result.products[0];
        media.innerHTML =
          iron && iron.image
            ? '<img src="' + iron.image + '" alt="' + (iron.title || '') + '" loading="lazy">'
            : '<div class="gg-fyf__best-media-ph"></div>';
      }

      var grid = results.querySelector('[data-gg-fyf-products]');
      grid.innerHTML = '';
      result.products.forEach(function (p, idx) {
        var card = document.createElement('article');
        card.className = 'gg-fyf__product' + (idx === 0 ? ' is-best' : '');
        var img = p.image
          ? '<img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">'
          : '<div class="gg-fyf__product-ph"></div>';
        var price = p.price != null ? '<p class="gg-fyf__product-price">' + money(p.price) + '</p>' : '';
        card.innerHTML =
          '<a class="gg-fyf__product-link" href="' +
          (p.url || '#') +
          '">' +
          img +
          '<p class="gg-fyf__product-role">' +
          (p.role || '') +
          '</p>' +
          '<h3 class="gg-fyf__product-title">' +
          (p.title || p.handle) +
          '</h3>' +
          price +
          '</a>' +
          '<button type="button" class="gg-fyf__product-atc" data-variant-id="' +
          (p.variantId || '') +
          '">Add with fit specs</button>';
        grid.appendChild(card);
      });
    }

    function runFit() {
      if (isIntake) {
        submitIntake();
        return;
      }
      var result = recommend(readInput(), catalog);
      if (!result) return;
      showStep(steps.length - 1);
      renderResults(result);
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.querySelectorAll('[data-gg-fyf-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Last actionable step is before thank-you panel
        if (stepIndex < steps.length - 2) showStep(stepIndex + 1);
        else runFit();
      });
    });

    if (form && isIntake) {
      // If the browser blocks submit due to a hidden invalid number field,
      // jump back to that step and show the native validation message.
      form.addEventListener(
        'invalid',
        function (e) {
          var el = e.target;
          if (!el || !el.willValidate) return;
          e.preventDefault();
          revealInvalidField(el);
        },
        true
      );

      var submitBtn = form.querySelector('[data-gg-fyf-submit]');
      if (submitBtn) {
        submitBtn.addEventListener('click', function (e) {
          var invalid = firstInvalidField();
          if (!invalid) return;
          e.preventDefault();
          revealInvalidField(invalid);
        });
      }

      form.addEventListener('submit', function (e) {
        var email = form.querySelector('[name="contact[email]"]');
        if (email && !String(email.value || '').trim()) {
          e.preventDefault();
          alert('Please enter an email so Junior Forged can send your fitting report.');
          showStep(steps.length - 2);
          email.focus();
          return;
        }
        // Block accidental Enter-key submits before the contact step
        if (stepIndex < steps.length - 2) {
          e.preventDefault();
          showStep(stepIndex + 1);
          return;
        }
        var invalid = firstInvalidField();
        if (invalid) {
          e.preventDefault();
          revealInvalidField(invalid);
          return;
        }
        prepareIntakePayload();
      });
    }

    root.querySelectorAll('[data-gg-fyf-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (stepIndex > 0) showStep(stepIndex - 1);
      });
    });

    root.querySelectorAll('[data-gg-fyf-recalc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(0);
        window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
      });
    });

    var addAll = root.querySelector('[data-gg-fyf-add-all]');
    if (addAll) {
      addAll.addEventListener('click', function () {
        if (!lastResult) return;
        var props = fitProperties(lastResult);
        var items = lastResult.products
          .filter(function (p) {
            return p.variantId;
          })
          .map(function (p) {
            return { id: Number(p.variantId), quantity: 1, properties: props };
          });
        if (!items.length) {
          alert('No products available to add yet.');
          return;
        }
        addItemsToCart(items, addAll);
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.gg-fyf__product-atc');
      if (!btn || !lastResult) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id) {
        var link = btn.closest('.gg-fyf__product').querySelector('a');
        if (link) window.location.href = link.href;
        return;
      }
      addItemsToCart([{ id: Number(id), quantity: 1, properties: fitProperties(lastResult) }], btn);
    });

    if (form && !isIntake) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        runFit();
      });
    }

    // After Shopify contact redirect (?contact_posted=true)
    var params = new URLSearchParams(window.location.search || '');
    if (
      isIntake &&
      (window.__GG_PLAYER_FIT_POSTED ||
        params.get('contact_posted') === 'true' ||
        params.get('customer_posted') === 'true')
    ) {
      showStep(steps.length - 1);
      if (results) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      showStep(0);
    }
  }

  function boot() {
    document.querySelectorAll('[data-gg-fyf]').forEach(init);
    scrollToCalculatorIfNeeded();
  }

  function scrollToCalculatorIfNeeded() {
    var target = document.getElementById('GgFindYourFit');
    if (!target) return;

    var shouldScroll = false;
    if (window.location.hash === '#GgFindYourFit' || window.location.hash === '#start-fitting') {
      shouldScroll = true;
    }

    if (shouldScroll) {
      window.requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="find-your-fit"]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var onFitPage = /\/pages\/find-your-fit\/?$/.test(window.location.pathname);
    var wantsCalc =
      href.indexOf('#GgFindYourFit') !== -1 ||
      href.indexOf('#start-fitting') !== -1 ||
      (onFitPage && href.indexOf('/pages/find-your-fit') !== -1);

    if (!wantsCalc) return;
    var target = document.getElementById('GgFindYourFit');
    if (!target) return;

    if (onFitPage) {
      e.preventDefault();
      history.replaceState(null, '', '#GgFindYourFit');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('hashchange', scrollToCalculatorIfNeeded);

  window.GgFindYourFit = { recommend: recommend };
})();
